export default class TeamApply implements Monitor.TeamApply {
    public logo: ImageInfo | null;
    /** 名称 */
    public name: string;
    /** 城市id */
    public city_id: number[];
    /** 组别id */
    public level_id: number | null;
    /** 描述 */
    public description: string;
    /** 群二维码 */
    public qr_code: Array<ImageInfo | null>;
    /** 生活照片key */
    public photos: ImageInfo[] | null;

    /** 微信号 */
    public we_chat_id: string | null;

    constructor(apply?: Monitor.RawTeamApply) {
        this.logo = apply?.logo ? apply.logo : null;
        this.name = apply?.name ? apply.name : '';
        // 使用-1用于实现全国
        this.city_id = apply ? (apply.city_id ? apply.city_id : [-1]) : [];
        this.level_id = apply?.level_id ? apply.level_id : null;
        this.description = apply?.description ? apply.description : '';
        this.qr_code = (apply?.group_qr_code && apply?.monitor_qr_code) ? [ apply.group_qr_code, apply.monitor_qr_code ] : [];
        this.photos = apply?.photos ? apply.photos : [];
        this.we_chat_id = apply?.we_chat_id ? apply.we_chat_id : null;
    }

    public toRaw() {
        const self = this;
        return {
            logo: self.logo ? self.logo.key : null,
            name: self.name,
            city_id: self.city_id && self.city_id.length && self.city_id[0] === -1 ? null : self.city_id,
            level_id: self.level_id,
            description: self.description,
            group_qr_code: self.qr_code[0] ? self.qr_code[0].key : null,
            monitor_qr_code: self.qr_code[1] ? self.qr_code[1].key : null,
            photos: self.photos?.map((photo) => photo.key),
            we_chat_id: self.we_chat_id,
        };
    }
}
